// InnerBanner.js
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { IMAGE_BASE_URL, images } from "../../appSettings/imageConstants.js"; 
import "../innerBanner/innerbanner.css"// Adjust the import path if necessary

const InnerBanner = ({ bannerImage, title, tagline }) => {
  return (
    <Box component="section" className="inner-banner">
      <Box className="pic">
        <Box
          component="img"
          src={bannerImage}
          alt="Banner"
          sx={{ width: "100%" }}
        />
      </Box>
      <Box className="inner-text">
      <Container maxWidth="xl">
          <Typography
            variant="h1"
            component="h1"
            color="white"
            align="center"
            className="font700"
          >
            {title}
          </Typography>
          <Typography
            variant="body1"
            component="p"
            color="white"
            align="center"
            sx={{ mt: 2 }}
          >
            {tagline}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default InnerBanner;
